// types
import { IFolder } from './types'

// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { IoFolderOpenOutline } from 'react-icons/io5'
import { useStyletron } from 'baseui';

export function OverviewPanel(props: IFolder) {

    const [,theme] = useStyletron();
    return (
        <OverviewPanelWrapper small icon={ <IoFolderOpenOutline size='100%' color={theme.colors.backgroundPrimary}/>} {...props}>
          
        </OverviewPanelWrapper>
    );
}